import { EZDropdown } from "@template-ui/types";
//import { DropdownConfig } from "./shared/dropdown-configs/dropdown-config.types";
import { DropdownRegistryService } from "@template-ui/services/dropdown-registry.service";
import { commonDropdownConfigFactories, DropdownKey } from "@app/shared/dropdown-configs/common.dropdown-config";

/**
 * Angular provider that initializes and populates the DropdownRegistryService at app startup.
 *
 * Iterates over all config factories, evaluates each one, and registers it with its respective key.
 *
 * This function can be used with `bootstrapApplication()` or inside `providers[]` in a standalone app setup.
 */
export function provideDropdownRegistry() {
    return [{
        provide: DropdownRegistryService,
        useFactory: () => {
            const registry = new DropdownRegistryService();

            (Object.entries(commonDropdownConfigFactories) as [DropdownKey, () => EZDropdown<any>][])
                .forEach(([key, createConfig]) => {
                    const config = createConfig();
                    registry.register(key, config);
                });

            return registry;
        }
    }];
}
